<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        Ustaw usługę dodatkową dla produktu
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-4">
      <div class="form-group">
        <label for="procedures">
          Wybierz usługę dodatkową do dodania
        </label>

        <div class="form-control">
          <v-select
            :options="procedures"
            v-model="selectedProcedure"
            placeholder="Wybierz procedurę"
            :searchable="true"
            :reduce="item => item.id"
            label="name">
          </v-select>
        </div>
      </div>

      <div class="form-group">
        <label>
          Gdzie dodać nową procedurę?
        </label>
        <d-button-group
          size="small"
          class="w-100">
          <d-button
            key="btn-at-begin"
            theme="primary"
            :outline="addAt !== 'begin'"
            @click.prevent="setBegin">
            Na początku
          </d-button>

          <d-button
            key="btn-at-end"
            theme="primary"
            :outline="addAt !== 'end'"
            @click.prevent="setEnd">
            Na końcu
          </d-button>
        </d-button-group>
      </div>
    </d-modal-body>
    <d-modal-footer class="p-3 pl-4 pr-4">
      <d-button
        theme="danger"
        @click.prevent="handleClose">
        Anuluj
      </d-button>

      <d-button
        :disabled="!selectedProcedure || saveInProgress"
        theme="success"
        @click.prevent="saveChanges"
        class="ml-auto">
        Dodaj dodatkową usługę
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from './../../../utils/FormUtils.js';

export default {
  name: 'order-special-procedure-popup',
  props: [
    'orderProductID',
    'procedures'
  ],
  data () {
    return {
      addAt: 'begin',
      saveInProgress: false,
      selectedProcedure: null
    };
  },
  methods: {
    handleClose () {
      this.selectedProcedure = null;
      this.$bus.$emit('close-order-special-procedure-popup');
    },
    setBegin () {
      Vue.set(this, 'addAt', 'begin');
    },
    setEnd () {
      Vue.set(this, 'addAt', 'end');
    },
    saveChanges () {
      FormUtils.submitInBackground(this, {
        endpoint: '/orders/add-product-procedure',
        params: {
          order_product_id: this.orderProductID,
          procedure_id: this.selectedProcedure,
          add_at: this.addAt
        },
        errorTitle: 'Wystąpił błąd',
        errorText: 'Dodawanie usługi dodatkowej nie powiodło się. Spróbuj ponownie',
        successAction: (data) => {
          if (data.success) {
            this.saveInProgress = false;
            window.location.reload();
          }

          this.saveInProgress = false;
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      });
    }
  }
}
</script>
